import { render, staticRenderFns } from "./PhotoPicker.vue?vue&type=template&id=83d536d0&"
import script from "./PhotoPicker.vue?vue&type=script&lang=js&"
export * from "./PhotoPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports